module.exports = __webpack_public_path__ + "nicon_caret_down.svg";